import { render, staticRenderFns } from "./email-logs.vue?vue&type=template&id=385572af&scoped=true&"
import script from "./email-logs.vue?vue&type=script&lang=js&"
export * from "./email-logs.vue?vue&type=script&lang=js&"
import style0 from "./email-logs.vue?vue&type=style&index=0&id=385572af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385572af",
  null
  
)

export default component.exports